<template>
  <div v-if="isLoggedIn" class="tw-ml-0 tw-mt-20 tw-px-4 tw-pb-8 xl:tw-ml-80 xl:tw-px-8">
    <slot />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { useSessionStore } from 'gpcore-apikit/store/pinia/session';

export default defineComponent({
  setup() {
    const sessionStore = useSessionStore();
    const isLoggedIn = computed(() => sessionStore.isLoggedIn);

    return {
      isLoggedIn,
    };
  },
});
</script>
